import { render, staticRenderFns } from "./TransferDeviceList.vue?vue&type=template&id=37a26512"
import script from "./TransferDeviceList.vue?vue&type=script&lang=js"
export * from "./TransferDeviceList.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports